<template>
  <div>
    <button
      type="button"
      class="btn btn-dark btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Bulk Payment
    </button>

    <a-modal v-model="visible" title="Bulk Fee Payment" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Upload</a-button>
      </template>

      <a-form :form="form">
<!--        <p>Select Session and class section to upload students.</p>
        <div class="row">
          <div class="col-md-4 mb-2">
            <a-form-item
              label="Session"
            >
              <a-select
                v-decorator="[
                  'session_id',
                  {rules: [{ required: true, message: 'Please select a session!!' }], initialValue: currentSession ? currentSession.id : ''}
                ]"
                placeholder="Select session"
                @change="handleSessionChange"
              >
                <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-3">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4 mb-2">
            <a-form-item
              label="Class"
            >
              <a-spin :spinning="classSpinning">
                <a-select
                  v-decorator="[
                    'class_id',
                    {rules: [{ required: false, message: 'Please select a class!!' }], initialValue: undefined}
                  ]"
                  placeholder="Select class"
                  @change="handleClassSelect"
                  :disabled="!selectedSession"
                >
                  <a-select-option :value="undefined">
                    Select Class
                  </a-select-option>
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

          <div class="col-md-4 mb-2">
            <a-form-item
              label="Section"
            >
              <a-spin :spinning="sectionSpinning">
                <a-select
                  v-decorator="[
                    'section_id',
                    {rules: [{ required: false, message: 'Please select a section!!' }], initialValue: undefined}
                  ]"
                  placeholder="Select section"
                  :disabled="!form.getFieldValue('class_id')"
                >
                    <a-select-option :value="undefined">
                      Select Section
                    </a-select-option>
                    <a-select-option v-for="section in sections" :value="section.id" :key="section.id">
                    {{section.name}}
                    </a-select-option>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

        </div>

        <a-divider /> -->
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item
              label="Fee"
            >
              <a-select
                v-decorator="[
                    'fee_id',
                    {rules: [{ required: false, message: 'Please select a fee to be paid.' }], initialValue: undefined}
                  ]"
                placeholder="Select fee"
              >
                <a-select-option :value="undefined">
                  Select Fee
                </a-select-option>
                <a-select-option v-for="fee in fees" :value="fee.id" :key="fee.id">
                  {{fee.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <p class="mt-3 mb-0">Please read the instruction file
          <a
            href="/resources/instructions/bulk_fee_payment_instruction.txt"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Download Instruction
          </a>
        </p>
        <p class="mt-3 mb-0">Download the csv file format here.
          <a
            href="/resources/csv/bulk_fee_payment.csv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Bulk Fee Payment
          </a>
<!--          <span class="font-weight-bold text-warning">Fields marked with * are required!</span>-->
        </p>
        <div class="row">
          <div class="col-md-4">
            <a-form-item
              label="CSV File"
            >
              <a-upload
                v-decorator="['file', {rules: [{ required: true, message: 'Please select a csv file to upload!' }]}]"
                accept=".csv, application/vnd.ms-excel, text/csv"
                :fileList="fileList"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="!uploadDisabled">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

export default {
  name: 'BulkFeePayment',
  mounted: function() {
    this.$http.get(`/api/fee`, {
    })
      .then(({ data }) => {
        this.fees = data.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedSession: undefined,
      classSpinning: false,
      sectionSpinning: false,
      fees: [],
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload (file) {
      const isCSV = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 50
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to make bulk fee payment.`,
            onOk: () => {
              let formData = window.jsonToFormData(values, options)
              const csvFile = values.file.file
              formData.append('file', csvFile)

              this.$http
                .post('/api/bulk_fee_payment', formData)
                .then(({ data }) => {
                  this.$emit('uploaded')
                  this.$eventBus.$emit('calendarEventUpdated')
                  this.loading = false
                  this.visible = false
                  this.$notification['info']({
                    message: 'Bulk fee payment started!',
                    description: `Bulk bulk fee payment started! You will be notified once it is completed!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
